import { AiScoringConstants } from '@/constants/ai-scoring-constants';

const getSliderConfig = (value: number) => {
  const { thresholdMap } = AiScoringConstants;
  if (value <= thresholdMap.low.to) return thresholdMap.low;
  if (value <= thresholdMap.average.to) return thresholdMap.average;
  if (value <= thresholdMap.high.to) return thresholdMap.high;
  return undefined;
};

const getScoreLevel = (value: string) => {
  const { thresholdMap } = AiScoringConstants;
  if (value === 'low') return thresholdMap.low;
  if (value === 'avg') return thresholdMap.average;
  if (value === 'high') return thresholdMap.high;
  return undefined;
};

export const aiScoringUtils = { getSliderConfig, getScoreLevel };
